module.exports = __webpack_public_path__ + "media/videos/term-bg-7-b54a3d9b.jpg";